/* WG grid — quick add, swatch swap, touch-carousel dots. */
(function () {
  'use strict';
  if (window.__wgGrid) return;
  window.__wgGrid = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function updateCount() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-wg-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addToCart(id, btn) {
    if (!id || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        updateCount();
        document.dispatchEvent(new CustomEvent('wg:cart:update'));
        var media = btn.closest('.wg-cell__media');
        if (media) media.classList.remove('wg-cell__media--open');
        setTimeout(function () {
          btn.classList.remove('is-done');
        }, 1600);
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        var cell = btn.closest('.wg-cell');
        var url = btn.getAttribute('data-url') || (cell && cell.getAttribute('data-url'));
        if (url) window.location.href = url;
      });
  }

  document.addEventListener('click', function (e) {
    var qa = e.target.closest('.wg-qa');
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      var mode = qa.getAttribute('data-mode');
      if (mode === 'single') {
        addToCart(qa.getAttribute('data-variant'), qa);
      } else if (mode === 'sizes') {
        var media = qa.closest('.wg-cell__media');
        if (media) media.classList.toggle('wg-cell__media--open');
      } else {
        window.location.href = qa.getAttribute('data-url');
      }
      return;
    }

    var size = e.target.closest('.wg-qa-size');
    if (size) {
      e.preventDefault();
      if (!size.disabled) addToCart(size.getAttribute('data-variant'), size);
      return;
    }

    var sw = e.target.closest('.wg-cell .wg-sw');
    if (sw) {
      e.preventDefault();
      var cell = sw.closest('.wg-cell');
      cell.querySelectorAll('.wg-sw').forEach(function (x) {
        x.classList.toggle('is-active', x === sw);
      });
      var img = cell.querySelector('.wg-media-track .wg-slide img');
      var src = sw.getAttribute('data-image');
      if (img && src) {
        img.removeAttribute('srcset');
        img.src = src;
      }
      var url = sw.getAttribute('data-url');
      if (url) {
        cell.querySelectorAll('a.wg-media-link, a.wg-cell__title').forEach(function (a) {
          a.href = url;
        });
      }
      return;
    }

    // close any open size strips when clicking elsewhere
    document.querySelectorAll('.wg-cell__media--open').forEach(function (m) {
      if (!m.contains(e.target)) m.classList.remove('wg-cell__media--open');
    });
  });

  function bindDots(ctx) {
    (ctx || document).querySelectorAll('.wg-cell__media [data-wg-track]').forEach(function (track) {
      if (track.__wgDots) return;
      var media = track.closest('.wg-cell__media');
      var dots = media && media.querySelector('[data-wg-dots]');
      if (!dots) return;
      track.__wgDots = true;
      track.addEventListener(
        'scroll',
        function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          dots.querySelectorAll('span').forEach(function (d, j) {
            d.classList.toggle('is-active', j === i);
          });
        },
        { passive: true }
      );
    });
  }

  /* ── tabbed grid: FLIP morph to a collection's cells ─────────────
     Shared products (matched by data-url) glide to their new slot;
     leaving products lift out of flow and fade (no reflow stall);
     entering products rise in. The hairline border matrix fades to
     transparent for the duration (grid.is-morphing) then back on settle
     — "fade the border array out and bring it back." */
  function cellsFromHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('.wg-cell'));
  }

  function keyOf(el) {
    return (el.getAttribute('data-url') || '').split('?')[0] || el.textContent;
  }

  function fetchCells(handle) {
    return fetch(root + 'collections/' + encodeURIComponent(handle) + '?view=wgcells', {
      headers: { 'X-Requested-With': 'fetch' },
    }).then(function (r) {
      if (!r.ok) throw new Error('fetch failed');
      return r.text();
    });
  }

  /* Snap any in-flight morph to a clean state before starting a new one. */
  function settleGrid(grid) {
    grid.classList.remove('is-morphing');
    Array.prototype.slice.call(grid.querySelectorAll('.wg-cell')).forEach(function (el) {
      if (el.style.position === 'absolute') { el.remove(); return; }
      el.style.transition = '';
      el.style.transform = '';
      el.style.opacity = '';
      el.style.willChange = '';
      el.style.position = '';
      el.style.top = '';
      el.style.left = '';
      el.style.width = '';
      el.style.margin = '';
      el.style.zIndex = '';
    });
  }

  function morphGrid(grid, targetCells) {
    var myId = (grid.__wgMorphId = (grid.__wgMorphId || 0) + 1);
    var alive = function () { return grid.__wgMorphId === myId; };

    var targetKeys = targetCells.map(keyOf);
    var targetSet = {};
    targetKeys.forEach(function (k) { targetSet[k] = 1; });

    var currentEls = Array.prototype.slice.call(grid.querySelectorAll('.wg-cell'));
    var currentByKey = {};
    currentEls.forEach(function (el) { currentByKey[keyOf(el)] = el; });

    /* FIRST: read old positions of persisting cards (one pass) */
    var firstRects = {};
    currentEls.forEach(function (el) {
      var k = keyOf(el);
      if (targetSet[k]) firstRects[k] = el.getBoundingClientRect();
    });
    var gridRect = grid.getBoundingClientRect();

    grid.classList.add('is-morphing');

    /* leaving cards lift out of flow so removal doesn't hold up the reflow */
    var leaving = currentEls.filter(function (el) { return !targetSet[keyOf(el)]; });
    leaving.forEach(function (el) {
      var r = el.getBoundingClientRect();
      el.style.position = 'absolute';
      el.style.margin = '0';
      el.style.top = (r.top - gridRect.top) + 'px';
      el.style.left = (r.left - gridRect.left) + 'px';
      el.style.width = r.width + 'px';
      el.style.zIndex = '0';
    });

    /* reorder to target in ONE write pass: reuse shared nodes, insert new */
    var entering = [];
    var frag = document.createDocumentFragment();
    targetCells.forEach(function (tc) {
      var el = currentByKey[keyOf(tc)];
      if (el) {
        frag.appendChild(el);
      } else {
        tc.style.opacity = '0';
        tc.style.transform = 'translate3d(0,12px,0) scale(0.985)';
        entering.push(tc);
        frag.appendChild(tc);
      }
    });
    grid.appendChild(frag);
    leaving.forEach(function (el) { grid.appendChild(el); });

    /* LAST: read new positions, invert shared cards to old spot */
    requestAnimationFrame(function () {
      if (!alive()) return;
      targetKeys.forEach(function (k) {
        var el = currentByKey[k];
        if (!el || !firstRects[k]) return;
        var last = el.getBoundingClientRect();
        var dx = firstRects[k].left - last.left;
        var dy = firstRects[k].top - last.top;
        el.style.willChange = 'transform';
        el.style.transition = 'none';
        el.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)';
      });

      requestAnimationFrame(function () {
        if (!alive()) return;
        targetKeys.forEach(function (k) {
          var el = currentByKey[k];
          if (!el || !firstRects[k]) return;
          el.style.transition = 'transform 0.5s cubic-bezier(0.22,0.61,0.36,1)';
          el.style.transform = 'translate3d(0,0,0)';
        });
        entering.forEach(function (el) {
          el.style.transition = 'opacity 0.42s ease, transform 0.42s cubic-bezier(0.22,0.61,0.36,1)';
          el.style.opacity = '1';
          el.style.transform = 'translate3d(0,0,0)';
        });
        leaving.forEach(function (el) {
          el.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
          el.style.opacity = '0';
          el.style.transform = 'scale(0.96)';
        });

        setTimeout(function () {
          if (!alive()) return;
          leaving.forEach(function (el) { el.remove(); });
          Array.prototype.slice.call(grid.querySelectorAll('.wg-cell')).forEach(function (el) {
            el.style.transition = '';
            el.style.transform = '';
            el.style.opacity = '';
            el.style.willChange = '';
          });
          grid.classList.remove('is-morphing');
          bindDots(grid);
        }, 560);
      });
    });
  }

  function initTabs(wrap) {
    if (wrap.__wgTabs) return;
    wrap.__wgTabs = true;
    var grid = wrap.querySelector('[data-wg-grid]');
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('.wg-tabs__tab'));
    if (!grid || !tabs.length) return;

    var count = parseInt(wrap.getAttribute('data-count'), 10) || 100;
    var cache = {};
    var reqId = 0;
    var activeHandle = null;

    var firstActive = wrap.querySelector('.wg-tabs__tab.is-active') || tabs[0];
    if (firstActive) {
      activeHandle = firstActive.getAttribute('data-handle');
      cache[activeHandle] = grid.innerHTML; // first tab is already server-rendered
    }

    function apply(html) {
      var cells = cellsFromHTML(html).slice(0, count);
      if (!cells.length) {
        settleGrid(grid);
        grid.innerHTML = '<p class="wg-grid__empty">Nothing here yet.</p>';
        return;
      }
      morphGrid(grid, cells);
    }

    function show(handle) {
      if (!handle || handle === activeHandle) return;
      activeHandle = handle;
      settleGrid(grid);
      var myReq = ++reqId;
      if (cache[handle] != null) {
        apply(cache[handle]);
        return;
      }
      grid.classList.add('is-swapping'); // subtle dim only while the network runs
      fetchCells(handle)
        .then(function (html) {
          if (myReq !== reqId) return;
          cache[handle] = html;
          grid.classList.remove('is-swapping');
          apply(html);
        })
        .catch(function () {
          if (myReq !== reqId) return;
          grid.classList.remove('is-swapping');
        });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var h = tab.getAttribute('data-handle');
        if (!h) return;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        show(h);
      });
    });
  }

  function initAllTabs(ctx) {
    (ctx || document).querySelectorAll('[data-wg-tabgrid]').forEach(initTabs);
  }

  bindDots(document);
  initAllTabs(document);
  document.addEventListener('shopify:section:load', function (e) {
    bindDots(e.target);
    initAllTabs(e.target);
  });
})();
